import { faCircleInfo } from "@jewlr/pro-light-svg-icons/faCircleInfo"
// import { faTag } from "@jewlr/pro-regular-svg-icons/faTag"
import {
  Box,
  Button,
  Divider,
  Flex,
  FontAwesomeIcon,
  MediaBox,
  MediaFlex,
  Typography,
} from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import { openModal } from "components/modal"
import { IS_AU, IS_CA, isTestMode, IS_JEWLR } from "helpers/application"
import { enableKlarnaCheckout } from "helpers/checkout/checkout_options"
import { number_with_delimiter, to_currency } from "helpers/number"
import scrollToElement from "helpers/scroll-to-element"

import WizardPricingLoading from "./loaders/wizard-pricing-loading"
import Ratings from "./ratings"
import Affirm from "./wizard-header/affirm"
import Badge from "./wizard-header/badge"
import Klarna from "./wizard-header/klarna"

const Pricing = styled(Typography).attrs((props) => ({
  color: "grey.62",
  fontSize: 12,
  letterSpacing: "1px",
  ...props,
}))``

// const SaleBubble = styled(Flex).attrs((props) => ({
//   alignItems: "center",
//   bg: props.theme.colors.sale,
//   borderRadius: "6px",
//   color: "white",
//   display: "inline-flex",
//   gap: "4px",
//   mb: { _: "10px", tablet: "6px" },
//   mt: { _: "12px", tablet: "8px" },
//   pb: "3px",
//   pt: "4px",
//   px: 1,
// }))``

// const Sale = styled(Typography).attrs({
//   fontSize: "13px",
//   fontWeight: "500",
//   textTransform: "uppercase",
// })``

const InternalProductPrice = ({
  isMiniview,
  cartSummary,
  hideMiniview,
  prefStore,
  pricing,
  saleEnds,
  wizardLoading,
}) => {
  const [priceToDisplay, setPriceToDisplay] = useState(
    pricing.price_to_display || 0
  )

  useEffect(() => {
    let calculatedPrice = pricing.price_to_display || 0

    if (cartSummary) {
      calculatedPrice += cartSummary.cart_total
    }

    setPriceToDisplay(calculatedPrice)
  }, [cartSummary, pricing.price_to_display])

  if (!prefStore || !Object.keys(pricing).length) {
    return <WizardPricingLoading />
  } else if (priceToDisplay <= 0 || wizardLoading) {
    return ""
  }

  const percentageSavings = (
    ((pricing.retail_price - pricing.price_to_display) * 100) /
    pricing.retail_price
  ).toFixed(0)

  let currencyCode = ""
  if (IS_AU()) {
    currencyCode = "AU"
  } else if (IS_CA()) {
    currencyCode = "C"
  }

  const handleRatingsClick = () => {
    scrollToElement("#product-reviews", hideMiniview ? 90 : 350)
    if (!isTestMode) {
      dataLayer.push({
        event: "clicked-reviews-count-pdp",
      })
    }
  }

  const handleHonestPricingClick = () => {
    openModal("#honest-pricing")
    if (!isTestMode) {
      dataLayer.push({
        event: "opened-pdp-honest-pricing-popup",
      })
    }
  }

  return (
    <>
      <MediaFlex justifyContent="center" lessThan="tablet">
        <Badge />
      </MediaFlex>
      <Flex
        alignItems={{ _: "center", desktop: "flex-start" }}
        flexDirection="column"
        mb="12px"
      >
        <Flex alignItems="center">
          <Typography
            bold
            color="sale"
            data-cy="product-item-price"
            fontSize="28px"
            lineHeight="34px"
          >
            {currencyCode}
            {sl.config.default_currency}
            {number_with_delimiter(parseFloat(pricing.price_to_display))}
          </Typography>
        </Flex>
        {IS_JEWLR() && (
          <Flex
            alignItems="center"
            fontSize="12px"
            letterSpacing="1px"
            lineHeight="14px"
          >
            <Typography color="sale" fontWeight="500">
              SAVE {percentageSavings}%
            </Typography>
            <Box
              bg="grey.35"
              height="12px"
              mx={1}
              role="separator"
              width="1px"
            />

            <Button
              aria-label={`Compare to ${to_currency(
                pricing.retail_price
              )} Estimated Retail. Read more about our value pricing`}
              onClick={handleHonestPricingClick}
              variant="text"
            >
              <Typography
                fontSize="12px"
                fontWeight="300"
                letterSpacing="1px"
                lineHeight="14px"
              >
                Compare to {to_currency(pricing.retail_price)} Estimated Retail
              </Typography>
              <FontAwesomeIcon
                color="black"
                fontSize="10px"
                icon={faCircleInfo}
                ml="4px"
              />
            </Button>
          </Flex>
        )}
      </Flex>
      {new Date().setHours(0, 0, 0, 0) <=
        new Date(saleEnds).setHours(0, 0, 0, 0) && (
        <Box textAlign="center">
          <Pricing color="#757575" letterSpacing="0">
            Sale ends {saleEnds}
          </Pricing>
        </Box>
      )}
      {IS_JEWLR() && (
        <>
          {!isMiniview && sl.config.use_yotpo && (
            <MediaBox lessThan="tablet" mb="15px" mt={1}>
              <Ratings handleClick={handleRatingsClick} />
              <Divider mt="12px" mx={3} />
            </MediaBox>
          )}
          {sl.config.enable_affirm && !isMiniview && (
            <MediaBox lessThan="tablet" mb="10px">
              <Affirm />
            </MediaBox>
          )}
          {sl.config.klarna_osm_pdp &&
            enableKlarnaCheckout() &&
            priceToDisplay <= sl.config.klarna_max &&
            !isMiniview && (
              <MediaBox lessThan="tablet" mb="10px">
                <Klarna />
              </MediaBox>
            )}
        </>
      )}
    </>
  )
}

InternalProductPrice.propTypes = {
  cartSummary: PropTypes.object,
  fetchCart: PropTypes.func,
  hideMiniview: PropTypes.bool,
  isMiniview: PropTypes.bool,
  prefStore: PropTypes.bool,
  pricing: PropTypes.object,
  saleEnds: PropTypes.string,
  wizardLoading: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    cartSummary: state.cart.summary,
    hideMiniview: state.previewImageUI.miniview.scrollHide,
    prefStore: state.wizardUI.prefStore,
    pricing: state.wizardUI.currentPricing,
    saleEnds: state.wizard.price_and_promo.sale_ends,
    wizardLoading: state.wizard.loading,
  }
}

const ProductPrice = connect(mapStateToProps)(InternalProductPrice)

export default ProductPrice
